import React from 'react';
import './ProblemSection.css';

export default function ProblemSection() {
  return (
    <section className="problem landing__section" aria-labelledby="problem-heading">
      <div className="landing__column landing__column--narrow">
        <div className="fade-up">
          <h2 className="problem__heading" id="problem-heading">
            The gap between<br />knowing and doing.
          </h2>
          <p className="problem__body">
            Most of us know, roughly, what we value. We've done the journaling,
            the ikigai exercise, the values card sort. We've read the books.
            We've had the therapy sessions where we figured out, for this year
            at least, what we're working toward.
          </p>
          <p className="problem__body">
            The problem is that none of it lives next to our Tuesday.
          </p>
          <p className="problem__body">
            The apps we use to track values and visions are separate from the
            apps we use to track tasks. So the Tuesday to-do list is about
            clearing email, not about the life you said you wanted to build.
            The gap between the inner work and the daily work stays open.
          </p>
        </div>
      </div>
    </section>
  );
}
